import { render } from "./HeadingFour.vue?vue&type=template&id=1cd49676&scoped=true"
import script from "./HeadingFour.vue?vue&type=script&lang=js"
export * from "./HeadingFour.vue?vue&type=script&lang=js"

import "./HeadingFour.vue?vue&type=style&index=0&id=1cd49676&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd49676"]])

export default __exports__